export default __webpack_public_path__ + "static/media/E5tGVR9VEAAYT-R.4cd94d26.jpg";